import React from 'react';
import LoggedInPage from './../core/LoggedInPage';
import PiechartComp from '../../views/scorecard/Piechart';
import HorizontalStepper from './HorizontalStepper';
import HmAjax from '../../util/HmAjax';
import ComponentRegistry from '../../model/ComponentRegistry';

export default class ContestDashboard extends LoggedInPage{
  constructor(props){
    super(props)
    this.state = {
      dataLoaded:false,
      data:null,
      dashboardStatus:"",
      stepsLoaded: true,
      registeredCount: false,
      pendingCount: false,
      countLoaded: false,
      forceUpdater: 0
    };

    this.currentStep = 0; 

      this.colorArr = ["#A3A0FB","#55D8FE","#FF8373","#FFDA83","#9ccc65","#78909c"]; //partiation color
    }

    componentDidMount(){
      this.getDashBoardData();
      this.getCount(this.loadCurrentStep);
    }

    getCount(callBack){
      let me = this;

      let contestId = (this.props.contest_host) ? this.props.contest_host.toUpperCase() : null;

      if(!contestId){
        return ;
      }

      let success = (resp, opts) => {
        if(resp && resp.message === "success"){
          me.setState({countLoaded: true, registeredCount: (!isNaN(resp.registered) ? resp.registered : 0), pendingCount: (!isNaN(resp.pending) ? resp.pending : 0)});

          if(typeof callBack === "function"){
            callBack.apply(this);
          }
        }
      }

      let failure = (err, opts) => {
       console.error("Error occurred while trying to fetch count.");           
       if(typeof callBack === "function"){
        callBack.apply(this);
      }
    }

    if(!this.state.countLoaded){
      new HmAjax(this.getUrlFor("CONTEST_USERS_GET_COUNT").replace("{#contestId}",contestId)).get(success, failure);
    }      
  }

  findCurrentStep(response){
    let currentTime = Math.round(new Date().getTime()/1000);

    try{
       if(currentTime >= response.resultDate){
         return 8;
       }else if(currentTime >= response.contestEndTime){
         return 7;
       }else if(currentTime >= response.contestStartTime){
         return 6;
       }else if(currentTime >= response.mockEndTime){
         return 6;
       }else if(currentTime >= response.mockStartTime){
         return 5;
       }else if(currentTime >= response.regnEndTime){
         return 4;
       }else if(this.state.registeredCount > 0){
         return 2;
       }else if(currentTime >= response.regnStartTime){
         return 1;
       }else if(currentTime >= response.earlyRegnEndTime){
         return 1;
       }else{
        return 1;
      }
  }catch(e){
    console.error("Error occurred while finding the step :" , e);
    return 1;
  }
}


loadCurrentStep(){
  let me = this;
  let contestId = (this.props.contest_host) ? this.props.contest_host.toUpperCase() : null;

  if(!contestId){
    return;
  }

  let success = (resp) => {
    if(resp && Object.keys(resp).length > 0){
     me.currentStep = me.findCurrentStep(resp);
     me.setState({stepsLoaded: true, forceUpdater:(me.state.forceUpdater++)});
   }
 }

 let failure = (err) => {
  console.error("Error occurred while getting loadCurrentStep : ", err);
}

new HmAjax(this.getUrlFor("GET_CONTEST_STEP_INFO").replace("{#contestId}",contestId)).get(success, failure);
}

getOverAllPrice(){
  let totprice = (this.state.data.contestOnlyPrice  || 0 ) + (this.state.data.regularRegnPrice  || 0 ) + (this.state.data.earlyBirdPrice  || 0 );
  return (totprice>0) ? this.state.data.currency+" "+totprice : "NA";
}

getContestOnlyPrice(){
  let contestOnlyPrice = this.state.data.contestOnlyPrice || 0;
  return (contestOnlyPrice>0) ? this.state.data.currency+" "+contestOnlyPrice : "NA";
}

getearlyBirdPrice(){
  let earlyBirdPrice = this.state.data.earlyBirdPrice || 0;
  return (earlyBirdPrice>0) ? this.state.data.currency+" "+earlyBirdPrice : "NA";
}


getregularRegnPrice(){
  let regularRegnPrice = (this.state.data.regularRegnPrice || 0);
  return (regularRegnPrice>0) ? this.state.data.currency+" "+regularRegnPrice : "NA";
}

getContestUsers(){
  let contestUsers = (this.state.data.regularRegnUsers || 0) + (this.state.data.earlyBirdUsers || 0) + (this.state.data.contestOnlyUsers || 0);
  return contestUsers;
}

getPrepUsers(){
  let prepUsers = (this.state.data.regularRegnUsers || 0) + (this.state.data.earlyBirdUsers || 0);
  return prepUsers;
}

getDashBoardData(){
  var me = this;

  let contest_host =  this.props.contest_host || this.getSelectedContestGroup();

  var success = function(response){
   //console.log("response dashboard ",response);
   if(response!==null && response.regnData){
     if(response.status==="success"){
      me.setState({dashboardStatus:"",data:response.regnData, dataLoaded:true});
    }else {
      me.setState({dashboardStatus:"",data:response.regnData, dataLoaded:true});
           //if(response.status==="failure" && response.message === "no_user_available")
           //me.setState({dashboardStatus:me.rb("contest.dashboard.nouser"),dataLoaded:true});
         }
       } 
     }

     var failure = function(err){

     }

     new HmAjax(this.getUrlFor("CONTEST_DASHBOARD")+"?contest_host="+contest_host).post(success, failure);
   }

   getLegendLi(label,value,index){
    let colorArr = this.colorArr || [];
    return(
      <li key={index}><i className="material-icons" style={{color : colorArr[index]}}>fiber_manual_record</i>{label}<span>{value}</span></li>
      )
    }

    getGradeSortedOrder = (arr) =>{
      let arrValue = arr.sort((a,b) => {
        try{
        if(a && b && a.match(/[0-9]+/g).length > 0 && b.match(/[0-9]+/g).length > 0){
        if(!isNaN(a.match(/[0-9]+/g)[0]) && !isNaN(b.match(/[0-9]+/g)[0])){
        return parseInt(a.match(/[0-9]+/g)[0])-parseInt(b.match(/[0-9]+/g)[0]);
        }
        }
        }catch(e){
        console.error(e);
        }
        
        return 0;
        })
        return arrValue;
    }

    getlegendFn(){
      //console.log("this.state.data ",this.state.data);
      let legendArr = this.state.data.usersPerLevel || {};
      let gradeArr = (Object.keys(legendArr).length>0 ? Object.keys(legendArr) : []);
      gradeArr =  this.getGradeSortedOrder(gradeArr);
      let me = this;
      return (
      <div className="col-sm-12 col-md-6 legend_sec">
      <ul>
      {
        gradeArr.map((grade,index)=>{
          //console.warn("grade getlegendFn ",grade);
          return me.getLegendLi(grade,legendArr[grade],index)
        })

      }
      </ul>
      </div>
      )
    }

    getLoadedView(){
      const me = this;
         let legendArr = this.state.data.usersPerLevel || {};

              const add = (a, b) =>
              a + b

              const piedata = Object.values(legendArr) || [];  //this.getGradeSortedOrder(gradeArr); //how many partitions you want
              let gradeArr = (Object.keys(legendArr).length>0 ? Object.keys(legendArr) : []);
              gradeArr =  this.getGradeSortedOrder(gradeArr);

              let dataArr = [];

              gradeArr.map((grade,index)=>{
                dataArr.push(legendArr[grade])
              })

              const sum = (piedata.reduce(add)>0) ? piedata.reduce(add) : 0;
              const piecolors = this.colorArr || [];
              const pieindata = [sum, "Total"];  //inside data of svg
              // use reduce to sum our array

              return(
               <div>
               <h3>{this.rb("dashboard.title")}</h3>
               <div className="col-md-12 stud_reg_data nopadding">
               

               <h4>{this.rb("stud.reg.title")}</h4>
               <div className="row piechartlegend">
               <div className="col-sm-12 col-md-6 piechart_sec">

               <PiechartComp
               data={dataArr}
               colors={piecolors}
               txtval={pieindata} hole={50} radius={100} textshow={"vertical"}/>


             {/* <PieChart_Contest data={donut}/> */}
             </div>   


             {this.getlegendFn()}
             <div className="clearfix"></div>
             </div>

             </div>
             { (() => {
                if(me.isRIContest()){
                  return me.getRIView();
                }
             })()}

            </div>
            )
    }

    isRIContest(){
      const contestGrp = (window.contest_host_groups && window.contest_host_groups[this.getContestHost()]) ? window.contest_host_groups[this.getContestHost()] : null;

      return (contestGrp === "RI");
    }

    getRIView(){
      return(<div>
        {/* <div className="col-12 other_data">
             <div className="col-sm-12 col-md-12 col-lg-6 prep_data nopadding">
             <h4>{this.rb("prep.course.title")}</h4>
             <div className="prep_content">
             <div className="sub_no">{this.getPrepUsers()}</div>
             <div>{this.rb("out.of.total")}<span className="total_no">{this.getContestUsers()}</span></div>                   
             </div>
             </div>
             <div className="col-sm-12 col-md-12 col-lg-6 invoice_data nopadding">
             <h4>{this.rb("invoice.title")}</h4>
             <span className="total_amt">{this.getOverAllPrice()}</span> 
             <div className="inv_content">
             <div className="cont_amt">{this.rb("contest.amt")}<span>{this.getContestOnlyPrice()}</span></div>
             <div className="earlybird_amt">{this.rb("earlybird_amt")}<span>{this.getearlyBirdPrice()}</span></div>
             <div className="prep_amt">{this.rb("prep.amt")}<span>{this.getregularRegnPrice()}</span></div>                   
             </div>
             </div>  
             <div className="clearfix"></div>            
             </div> */}
            <br/>
             <h3>{this.rb("RIPMWC.title")}</h3>
             <div className="col-12 steps_progress nopadding">
                <div className="steps_chart" onClick={(()=>{window.location.href="/trail"})}>
                  {(() => { 
                    if(this.state.stepsLoaded){
                      return <HorizontalStepper currentStep={this.currentStep} />
                    }
                  })()}
                </div>
          </div>
</div>

        )
    }

    render(){
      let me=this;

      if(!this.state.dataLoaded){
        return(
        <div>
        {this.showLoader()}
        </div>
        )
      }
      else if(this.state.dataLoaded && this.state.data===null){
       return(
       <div>
       {this.state.dashboardStatus}
       </div>
       )
     }
     else{
        return this.getLoadedView();     
          } 

        }
      }


  ComponentRegistry.register("ri_ContestDashboard",ContestDashboard);


// WEBPACK FOOTER //
// ./src/views/contest/ContestDashboard.js